import { render, staticRenderFns } from "./CollectFreeMasks.vue?vue&type=template&id=75d1f049&scoped=true&"
import script from "./CollectFreeMasks.vue?vue&type=script&lang=js&"
export * from "./CollectFreeMasks.vue?vue&type=script&lang=js&"
import style0 from "./CollectFreeMasks.vue?vue&type=style&index=0&id=75d1f049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d1f049",
  null
  
)

export default component.exports